import {
  cn,
  Col,
  ContentCard,
  humanReadableAddress,
  Row,
} from '@rematter/ui-web';
import { LucideTag } from 'lucide-react';

import type { LoadsTabListItem } from '../../../types/load';
import { LoadStatusBadge } from '../StatusBadges';

type LoadListItemProps = {
  load: LoadsTabListItem;
  isSelected: boolean;
  showBorder?: boolean;
  onClick: () => void;
};

// ⚛️ ⚛️ ⚛️ LOAD LIST ITEM ⚛️ ⚛️ ⚛️
export const LoadListItem: React.FC<LoadListItemProps> = ({
  load,
  isSelected,
  showBorder = false,
  onClick,
}) => {
  const shippingAddress = load.shippingAddress
    ? humanReadableAddress({
        streetAddress: load.shippingAddress.streetAddress ?? '',
        city: load.shippingAddress.city ?? '',
        state: load.shippingAddress.state ?? '',
        postalCode: load.shippingAddress.postalCode ?? '',
      })
    : null;

  return (
    <ContentCard
      className={cn(
        '@LoadListItem',
        'relative flex-shrink-0',
        'cursor-pointer px-4 py-3 hover:bg-neutral/5',
        !showBorder &&
          'border border-transparent after:absolute after:right-3 after:bottom-0 after:left-3 after:h-px after:bg-neutral/10',
        isSelected && 'border-2 border-primary',
      )}
      onClick={onClick}
    >
      <Col gap1>
        <Row xBetween>
          <span className="truncate text-base font-semibold text-neutral">
            {load.loadNumber}
          </span>
          <LoadStatusBadge status={load.status} isReviewed={load.reviewed} />
        </Row>
        <Col>
          <p className="truncate text-base font-semibold text-neutral">
            {load.customerName}
          </p>
          {shippingAddress && (
            <p className="truncate text-sm text-neutral">{shippingAddress}</p>
          )}
        </Col>
        <Row yCenter gap1 className="text-neutral/50">
          <LucideTag className="size-4" />
          <span className="text-xs font-medium">{load.lineItemCount}</span>
        </Row>
      </Col>
    </ContentCard>
  );
};
